import { CALL_API } from "redux-api-middleware";
import regionApi from "apis/region";
import {
    REQUEST_STATES_LIST,
    RECEIVE_STATES_LIST,
    ERROR_STATES_LIST,

    REQUEST_COUNTIES_BY_STATE,
    RECEIVE_COUNTIES_BY_STATE,
    ERROR_COUNTIES_BY_STATE,

    REQUEST_ALL_COUNTIES,
    RECEIVE_ALL_COUNTIES,
    ERROR_ALL_COUNTIES,

    REQUEST_ALL_SERVICE_REGIONS,
    RECEIVE_ALL_SERVICE_REGIONS,
    ERROR_ALL_SERVICE_REGIONS,

    REQUEST_ASSIGN_STATES_MANAGER,
    RECEIVE_ASSIGN_STATES_MANAGER,
    ERROR_ASSIGN_STATES_MANAGER,

    REQUEST_ASSIGN_COUNTIES_MANAGER,
    RECEIVE_ASSIGN_COUNTIES_MANAGER,
    ERROR_ASSIGN_COUNTIES_MANAGER,

    REQUEST_COUNTY_BOUNDARIES_LIST,
    RECEIVE_COUNTY_BOUNDARIES_LIST,
    ERROR_COUNTY_BOUNDARIES_LIST,
    CLEAR_COUNTY_BOUNDARIES_LIST,
} from "typeConstants";
import responseHandler from "responseHandler";
import { WebApiReduxRequest, HTTP_GET, HTTP_POST } from "tools/webservice";
import serviceRegions from "apis/serviceRegion";

const getStates = () => {
    return function (dispatch) {

        dispatch({
            [CALL_API]:
                {
                    endpoint: regionApi.getStates(),
                    method: "GET",
                    types: [
                        REQUEST_STATES_LIST,
                        {
                            type: RECEIVE_STATES_LIST,
                            payload: (action, state, res) =>
                                res.json()
                                    .then(data => {
                                        return data;
                                    })
                        },
                        {
                            type: ERROR_STATES_LIST,
                            payload: (action, state, res) => {
                                responseHandler.error(res, dispatch);
                            }
                        }
                    ]
                }
        });
    };
};

const getCountiesByState = (states) => {
    return WebApiReduxRequest(
        REQUEST_COUNTIES_BY_STATE,
        RECEIVE_COUNTIES_BY_STATE,
        ERROR_COUNTIES_BY_STATE,
        HTTP_POST,
        regionApi.getCounties(),
        { stateAbbrevation: states }
      );
};

const getAllCounties = () => {
    return WebApiReduxRequest(
        REQUEST_ALL_COUNTIES,
        RECEIVE_ALL_COUNTIES,
        ERROR_ALL_COUNTIES,
        HTTP_POST,
        regionApi.getCounties()
      );
};

const getAllServiceRegions = (type) => {
    return WebApiReduxRequest(
        REQUEST_ALL_SERVICE_REGIONS,
        RECEIVE_ALL_SERVICE_REGIONS,
        ERROR_ALL_SERVICE_REGIONS,
        HTTP_GET,
        serviceRegions.getServiceRegions(type)
    );
};

const getServiceRegions = (type, searchTerm) => {
    return WebApiReduxRequest(
        REQUEST_ALL_SERVICE_REGIONS,
        RECEIVE_ALL_SERVICE_REGIONS,
        ERROR_ALL_SERVICE_REGIONS,
        HTTP_GET,
        serviceRegions.searchServiceRegions(type, searchTerm)
    );
};

const getCountyBoundaries = (countyIds) => {
    return function (dispatch, getState) {

        let idsToLoad = null;

        if (countyIds) {
            //filter out ids we may have already loaded
            let boundaries = getState().region.countyBoundaries;
            let keys = Object.keys(boundaries);
            let currentIds = keys.map(k => boundaries[k].properties.id);
            idsToLoad = countyIds.filter(cid => !currentIds.some(id => id === cid));
        }

        dispatch({
            [CALL_API]:
                {
                    endpoint: regionApi.getCountyBoundaries(),
                    method: "POST",
                    body: idsToLoad && JSON.stringify(idsToLoad),
                    types: [
                        REQUEST_COUNTY_BOUNDARIES_LIST,
                        {
                            type: RECEIVE_COUNTY_BOUNDARIES_LIST,
                            payload: (action, state, res) => res.json().then(data => data)
                        },
                        {
                            type: ERROR_COUNTY_BOUNDARIES_LIST,
                            payload: (action, state, res) => responseHandler.error(res, dispatch)
                        }
                    ]
                }
        });
    };
};

const clearLoadedCountyBoundaries = () => {
    return dispatch => dispatch({ type: CLEAR_COUNTY_BOUNDARIES_LIST });
};


const assignAppraiserManagerToStates = (assignStates) => assignUserToStates(assignStates, regionApi.assignAppraiserManagerToStates());

const assignAppraiserManagerToCounties = (assignCounties) => assignUserToCounties(assignCounties, regionApi.assignAppraiserManagerToCounties());

const assignFieldRepManagerToStates = (assignStates) => assignUserToStates(assignStates, regionApi.assignFieldRepManagerToStates());

const assignFieldRepManagerToCounties = (assignCounties) => assignUserToCounties(assignCounties, regionApi.assignFieldRepManagerToCounties());

const assignLenderLogisticsManagerToStates = (assignStates) => assignUserToStates(assignStates, regionApi.assignLenderLogisticsManagerToStates());

const assignLenderLogisticsManagerToCounties = (assignCounties) => assignUserToCounties(assignCounties, regionApi.assignLenderLogisticsManagerToCounties());

const assignUserToStates = (assignStates, endPoint) => {
    return dispatch => (
        dispatch({
            [CALL_API]: {
                endpoint: endPoint,
                method: "POST",
                body: JSON.stringify(assignStates),
                types: [
                    REQUEST_ASSIGN_STATES_MANAGER,
                    {
                        type: RECEIVE_ASSIGN_STATES_MANAGER,
                        payload: (action, state, res) => {
                            res.json()
                                .then(data => {
                                    setTimeout(() => {
                                        let message = "State(s) Assigned to Manager";
                                        responseHandler.success(message, dispatch);
                                    }, 0);
                                    return data;
                                });
                        }
                    },
                    {
                        type: ERROR_ASSIGN_STATES_MANAGER,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                            return assignUserToStates;
                        }
                    }
                ]
            }
        })
    );
};

const assignUserToCounties = (assignCounties, endPoint) => {
    return dispatch => (
        dispatch({
            [CALL_API]: {
                endpoint: endPoint,
                method: "POST",
                body: JSON.stringify(assignCounties),
                types: [
                    REQUEST_ASSIGN_COUNTIES_MANAGER,
                    {
                        type: RECEIVE_ASSIGN_COUNTIES_MANAGER,
                        payload: (action, state, res) => {
                            res.json()
                                .then(data => {
                                    setTimeout(() => {
                                        let message = "Counties Assigned to Manager";
                                        responseHandler.success(message, dispatch);
                                    }, 0);
                                    return data;
                                });
                        }
                    },
                    {
                        type: ERROR_ASSIGN_COUNTIES_MANAGER,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                            return assignUserToCounties;
                        }
                    }
                ]
            }
        })
    );
};
export {
    getStates,
    getCountiesByState,
    getAllCounties,
    getAllServiceRegions,
    assignAppraiserManagerToStates,
    assignAppraiserManagerToCounties,
    assignFieldRepManagerToStates,
    assignFieldRepManagerToCounties,
    assignLenderLogisticsManagerToStates,
    assignLenderLogisticsManagerToCounties,
    getCountyBoundaries,
    clearLoadedCountyBoundaries,
    getServiceRegions,
};
